import type { Guide, GuideRecordHint } from '../types';

/** S-20.10-02 — termin ważności wariantu i konflikt w czasie (scenariusz e2e 13, ścieżka FTL-02). */
const WITH_VARIANTS: GuideRecordHint = {
  description: 'zlecenie z wariantami pojazdów',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};

export const guide: Guide = {
  flagKey: 'variantValidity',
  title: 'Termin ważności wariantu i konflikt w czasie',
  whatItDoes:
    'Nowy wariant dostaje termin ważności — najbliższa 17:00, co najmniej godzinę po dodaniu (wartość robocza). Termin zmienia autor wariantu albo Team Leader, z powodem. Wariant po terminie ma oznaczenie, ale nie zwalnia się sam. Konflikt w czasie — ten sam pojazd jest wariantem albo obsadzeniem innego zlecenia w nachodzącym czasie — to znacznik, nie blokada; w banku są filtry „Konflikt wariantów w czasie” i „Wariant po terminie”.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-20.10-02'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: WITH_VARIANTS,
      target: 'variant-validity-*',
      mockupTestId: 'ftl-zlecenie-obsadzenie',
      title: 'Termin ważności przy wariancie',
      description:
        'Przy każdym wariancie: autor i „ważny do …”. Swój termin zmienisz przyciskiem obok — z powodem, zmiana trafia do historii zlecenia.',
      action: 'Przy swoim wariancie kliknij „Zmień termin”, wybierz datę i wpisz powód.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/V01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: WITH_VARIANTS,
      target: 'variant-time-conflict-*',
      title: 'Konflikt w czasie',
      description:
        'Gdy ten sam pojazd jest wariantem innego zlecenia w nachodzącym czasie, przy wariancie stoi numer tamtego zlecenia. Decyzja zostaje u Team Leadera.',
      action: 'Otwórz zlecenie z konfliktu i uzgodnij, które ma dostać pojazd.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/V01' } },
    },
    {
      route: '/user-offers',
      routeFilter: { forklift: 'variantConflict' },
      target: 'marker-variant-conflict',
      title: 'Znacznik i filtr w banku',
      description:
        'W banku zleceń znacznik „konflikt” i filtr „Znaczniki” → „Konflikt wariantów w czasie”; tak samo „Wariant po terminie”.',
      action: 'Na liście zleceń wybierz w „Znaczniki” „Konflikt wariantów w czasie”.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/user-offers',
      routeFilter: { forklift: 'variantExpired' },
      target: 'marker-variant-expired',
      title: 'Wariant po terminie',
      description:
        'Wariant po terminie nie znika sam — zwalnia go autor albo Team Leader. Do tego czasu ma znacznik „po terminie” na karcie i w banku.',
      action: 'Wybierz w „Znaczniki” „Wariant po terminie” i zdecyduj: przedłuż termin albo zwolnij wariant.',
      recorder: { account: 'ftl' },
    },
  ],
};
